import React from 'react';
import LazyImage from '../../components/LazyImage';

const HeroSection: React.FC = () => {
  return (
    <section className="relative h-[400px] md:h-[500px] flex items-center">
      {/* Background Image */}
      <LazyImage 
        src="/images/ComingSoon.webp" 
        alt="Mining site background" 
        className="absolute inset-0 w-full h-full object-cover"
        priority={true}
        preload={true}
        sizes="100vw"
      />
      
      
      
      {/* Content Overlay */}
      <div className="relative z-20 mx-auto px-4 md:px-10 lg:px-32 w-full pt-20 pb-20">
        <div className="w-full">
          {/* Heading */}
          <h1 className="text-[#FFFFFF] text-center text-[30px] md:text-[40px] lg:text-[65px] font-[700] leading-[45px] md:leading-[52px] lg:leading-[80px] lg:mb-2 mb-10 md:mb-8 w-full">
            Blog
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

